import { ReactNode, memo } from 'react';
import { Text, StackView } from '@cronos-labs/tectonic-ui-kit';
import clsx from 'clsx';

import Card from '@components/Card';
export interface MarketsSummaryCellProps {
  className?: string;
  label: string;
  value: ReactNode;
}

function MarketsSummaryCell({
  className,
  label,
  value,
  ...rest
}: MarketsSummaryCellProps): JSX.Element {
  return (
    <div className={clsx('font-medium', className)} {...rest}>
      <Text className="mb-1 text-mediumSmall font-normal" as="h1">
        {label}
      </Text>
      {value}
    </div>
  );
}

export interface MarketsSummaryProps {
  totalBorrow: ReactNode;
  totalSupply: ReactNode;
  supplyLabel?: string;
  borrowLabel?: string;
  isTopBanner?: boolean;
}

function MarketsSummary({
  totalSupply,
  totalBorrow,
  supplyLabel,
  borrowLabel,
  isTopBanner,
}: MarketsSummaryProps): JSX.Element {
  return (
    <Card padding="small">
      <StackView
        direction="horizontal"
        className={clsx(
          'mb-0 tablet:-m-2 tablet:flex-row tablet:p-2 mobile:-m-2 mobile:flex-col mobile:p-2',
          {
            'bg-mushroom-market-mobile bg-right bg-no-repeat desktop:!bg-none tablet:bg-contain mobile:bg-cover':
              !isTopBanner,
          }
        )}
      >
        <MarketsSummaryCell
          className={clsx(
            'desktop:-mt-2 desktop:-mb-2 desktop:pb-2 desktop:pt-2 mobile:mb-2 mobile:items-baseline',
            {
              'text-mediumSmall font-normal mobile:mb-2 mobile:flex mobile:justify-between':
                isTopBanner,
            }
          )}
          label={supplyLabel ?? 'Total supply'}
          value={totalSupply}
        />
        <MarketsSummaryCell
          className={clsx(
            'mix-blend-lighten desktop:-mt-2 desktop:-mb-2 desktop:bg-right-top desktop:bg-no-repeat desktop:pb-2 desktop:pt-2 mobile:items-baseline',
            {
              'text-mediumSmall font-normal desktop:bg-market-banner-firstly mobile:flex mobile:justify-between':
                isTopBanner,
              'desktop:bg-market-banner-second': !isTopBanner,
            }
          )}
          label={borrowLabel ?? 'Total borrow'}
          value={totalBorrow}
        />
      </StackView>
    </Card>
  );
}

export default memo(MarketsSummary, (prev, next) => {
  return (
    prev.totalBorrow === next.totalBorrow &&
    prev.totalSupply === next.totalSupply &&
    prev.supplyLabel === next.supplyLabel &&
    prev.borrowLabel === next.borrowLabel &&
    prev.isTopBanner === next.isTopBanner
  );
});
